import { useDispatch } from 'hooks/utils';
import { useActivity } from 'hooks/store';
import { Operation } from 'hooks/store/types';
import { ActionTypes, updateCollaboratorPermissions } from 'store/data/collaborators';

type HandlerInput = Parameters<typeof updateCollaboratorPermissions>[0];

export function useUpdateCollaboratorPermissions(): Operation<(input: HandlerInput) => void> {
	const dispatch = useDispatch();

	const [{ loading, error }, resetError] = useActivity(
		ActionTypes.UPDATE_COLLABORATOR_PERMISSIONS
	);

	function handler(input: HandlerInput) {
		if (loading) return;
		if (error) resetError();

		dispatch(updateCollaboratorPermissions(input));
	}

	return [{ loading, error }, handler];
}
